import { render, staticRenderFns } from "./ViewCustomerCoupons.vue?vue&type=template&id=03ea410c&scoped=true&"
import script from "./ViewCustomerCoupons.vue?vue&type=script&lang=js&"
export * from "./ViewCustomerCoupons.vue?vue&type=script&lang=js&"
import style0 from "./ViewCustomerCoupons.vue?vue&type=style&index=0&id=03ea410c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ea410c",
  null
  
)

export default component.exports